import { render, staticRenderFns } from "./eventsPerson.vue?vue&type=template&id=3b81deea&scoped=true"
import script from "./eventsPerson.vue?vue&type=script&lang=js"
export * from "./eventsPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81deea",
  null
  
)

export default component.exports